import classNames from 'classnames'
import SectionWrapper from '../SectionWrapper'
import Title from '../Title'
import MediaModal from '../MediaModal'
import { useModalStore } from 'store'
import { Content } from 'types/app'
import s from './index.module.scss'
import { getImageProcessorUrl } from 'helpers'
import RecentCarousel from 'components/RecentCarousel'
import { SwiperSlide } from 'swiper/react'

interface Props {
	type: 'photos' | 'reelz'
	place?: 'sidebar' | 'default'
	data: Content[]
}

const MediaWrapper = ({ type, data, place }: Props): JSX.Element => {
	const openModal = (itemIndex: number): void => {
		const { setModal } = useModalStore.getState()
		setModal({
			show: true,
			children: (
				<MediaModal
					onClose={() => setModal(null)}
					mediaItems={data}
					itemIndex={itemIndex}
				/>
			),
		})
	}

	const placeholder =
		type === 'photos' ? '/picture-placeholder.png' : '/showreel-placeholder.png'

	return data?.length ? (
		<SectionWrapper style={{ gap: '12px' }}>
			<>
				<Title text={`APP_${type.toUpperCase()}_TITLE`} />
				<RecentCarousel name={'profile-' + type} arrowClass={s.arrowSlider}>
					{data?.map((content, index) => (
						<SwiperSlide key={content?.ContentId}>
							<div
								className={classNames(
									s.wrapper,
									s[type],
									s[place + type || ''],
								)}
								onClick={() => openModal(index)}>
								<img
									alt={content?.ContentTitle}
									src={
										getImageProcessorUrl(
											content?.ContentSquareImageUrl,
											type === 'photos' ? 200 : 250,
										) || placeholder
									}
									onError={(e) => {
										const target = e.target as HTMLImageElement
										target.src = placeholder
									}}
								/>
							</div>
						</SwiperSlide>
					))}
				</RecentCarousel>
			</>
		</SectionWrapper>
	) : (
		<></>
	)
}

export default MediaWrapper
